/**
 * Single source of truth for admin shell routes used by the sidebar.
 * Import these paths elsewhere (router, deep links) instead of duplicating strings.
 */
export const NAVBAR_PATHS = Object.freeze({
    dashboard: '/dashboard',
    treasury: '/treasury',
    configurations: '/configurations',
    billing: '/billing',
    team: '/team',
    reports: '/reports',
    reviews: '/reviews',
    uploadsSimulator: '/uploads-simulator',
    support: '/support',
    notifications: '/notifications',
    account: '/account',
    roles: '/roles',
});

/** Brand block navigates to account settings. */
export const NAVBAR_BRAND_PATH = NAVBAR_PATHS.account;

/**
 * Routes that are not under a navbar section path prefix but should still
 * highlight that section (legacy reporting + team entry URLs).
 * Sub-routes like /configurations/* or /support/ticket are handled by
 * NavigationBar prefix matching and do not need entries here.
 */
export const NAVBAR_ACTIVE_PATH_ALIASES = Object.freeze({
    '/ledger': NAVBAR_PATHS.reports,
    '/reconciliation': NAVBAR_PATHS.reports,
    '/users': NAVBAR_PATHS.team,
    '/users/user': NAVBAR_PATHS.reports,
});
